import QuestionNewComment from './QuestionNewComment';

export default QuestionNewComment;
